// ===========================================
// Note Visibility Chip Component
// ===========================================

import { Chip } from '@mui/material';
import {
  School as StudentIcon,
  Person as PersonIcon,
  Lock as LockIcon,
  Visibility as ViewIcon,
} from '@mui/icons-material';
import {
  NoteVisibility,
  getNoteVisibilityLabel,
  getNoteVisibilityColor,
} from '../../../api/notes.api';

interface NoteVisibilityChipProps {
  visibility: NoteVisibility;
}

export default function NoteVisibilityChip({ visibility }: NoteVisibilityChipProps) {
  const getIcon = () => {
    switch (visibility) {
      case 'TEACHERS_ONLY':
        return <LockIcon sx={{ fontSize: 14 }} />;
      case 'PARENTS':
        return <PersonIcon sx={{ fontSize: 14 }} />;
      case 'STUDENTS':
        return <StudentIcon sx={{ fontSize: 14 }} />;
      default:
        return <ViewIcon sx={{ fontSize: 14 }} />;
    }
  };

  return (
    <Chip
      icon={getIcon()}
      label={getNoteVisibilityLabel(visibility)}
      size="small"
      color={getNoteVisibilityColor(visibility)}
      sx={{ height: 22, '& .MuiChip-label': { px: 1 } }}
    />
  );
}
